<template>
  <section class="auth-summer-page bg-no-repeat bg-center bg-cover w-full min-h-[100vh]">
    <div class="auth-summer-wrap w-full relative mx-auto flex flex-col justify-between items-center max-w-[1400px]">

      <div class="auth-summer-panel pt-[140px] max-w-[520px] w-full">
        <!--Log in-->
        <div class="auth-summer-card w-full box-border px-[45px] pt-[40px] pb-[44px] m-0 bg-white shadow-xl rounded-[10px]">
          <h6 class="text-[39px] text-center"><img class="w-[41px] h-[41px] max-w-full mr-[15px] inline-block" src="@/assets/logo-square.png"/><span class="text-[#00414a]">{{ $t("login.title") }}</span></h6>
          <p class="text-[14px] p-0 mt-[30px] mx-auto mb-[39px] w-auto max-w-[620px] font-normal leading-[24px] text-center text-[#223265] tracking-normal">{{ $t("login.slogan") }}</p>
          
          <el-form :model="dataForm" :rules="rules" ref="ruleForm" hide-required-asterisk >
              <el-form-item prop="username">
                <label class="w-full leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("login.fields.email") }}</label>
                <el-input v-model="dataForm.username" @focus="focusIndex = 0" @blur="focusIndex = null" clearable :placeholder="$t('login.fields.email_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>
            
              <el-form-item prop="password">
                <div class="flex justify-between items-center text-[#999999] text-[14px]">
                    <label class="w-max leading-none h-auto inline-block text-[12px] text-[#313942cc] tracking-normal font-normal relatvie top-[5px]">{{ $t("login.fields.password") }}</label>
                    <div class="cursor-pointer">
                        <a href="/findpassword/" class="text-[12px] font-normal text-[#2F80ED]">{{ $t("login.instructions.forgot_password") }}</a>
                    </div>
                </div>
                <el-input type="password" v-model="dataForm.password" clearable show-password @focus="focusIndex = 1" @blur="focusIndex = null" :placeholder="$t('login.fields.password_placeholder')" class="h-[25px] text-[16px] border-none font-normal tracking-normal outline-0 !bg-transparent"></el-input>
              </el-form-item>

              <cfturnstile :sitekey="sitekey" @verify="verify" @fail="onTurnstileFailed"/>
          </el-form>

          <div class="flex flex-row items-center text-center mt-[20px] text-[12px] align-bottom">
            <el-checkbox v-model="checked" size="medium"></el-checkbox>
            <span class="ml-[10px] text-[#313942cc]" @click="checked = !checked">{{ $t("login.fields.agreement.text1") }} </span><a @click="open" class="inline-block px-[4px] text-[12px] text-[#2F80ED] no-underline cursor-pointer">{{ $t("login.fields.agreement.text2") }}</a>
          </div>

          <el-button @click="clickLogin('ruleForm')" type="primary" round :loading="Loading" :disabled="disabled" class="mt-[25px] text-[16px] w-full cursor-pointer shadow-xl">{{ disabled ? disabledStr : $t("login.fields.action") }}</el-button>
          
          <p class="text-[14px] font-normal text-[#a7aab0] mt-[24px] text-center align-baseline">{{ $t("login.instructions.signup_instruction") }} <a href="/signup/" target="_self" class="text-[#3c7fff] underline" @click.prevent="openSignUp">{{ $t("login.instructions.signup") }}</a></p>
        </div>

        <modalPrivacy @agree="clickAgreePrivacy" ref="modalPrivacy"></modalPrivacy>
      </div>

      <!--left-->
      <div class="pt-[249px] w-[555px] hidden">
        <!--solution-->
        <div class="box-border w-full py-[53px]"> 
          <!--title-->
          <h2 class="mb-[30px] text-[17px] font-bold text-[#080808FF]"><span class="text-[#3C7FFFFF]">{{ $t("login.adv.s1") }}</span> {{ $t("login.adv.s2") }}</h2>
          <!--solution list-->
          <ul class="flex w-full">
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("login.features.f1") }}</span>
              </li>
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("login.features.f2") }}</span>
              </li>
          </ul>
          <!--solution list-->
          <ul class="flex w-full">
            <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("login.features.f3") }}</span>
              </li>
              <li class="w-[50%] mb-[20px] flex items-center text-[14px] font-[600] text-[#080808FF]">
                  <img src="@/assets/index/img/login/mark.webp" alt="" class="mr-[9px] w-[12px] h-[12px]" >
                  <span>{{ $t("login.features.f4") }}</span>
              </li>
          </ul>
        </div>
        <!--follow us-->
        <!-- <div class="follow_us_box">
            <img src="@/assets/index/img/login/proxy_img.webp" alt="">
        </div> -->
      </div> <!-- left end -->
    </div>
  </section>
</template>

<script>
import {login,getUser} from '@/http/api/member'
import TurnstileWidget from '@/components/turnstile-widget'
import modalPrivacy from './modalPrivacy'
import md5 from 'js-md5'
import { cookieAuthEnabled, saveCookieAuthState } from '@/http/authMode'
export default {
  name: 'login',
    components:{
        modalPrivacy,
        'cfturnstile': TurnstileWidget,
    },
  data() {
    return {
      sitekey: process.env.VUE_APP_SITEKEY,

      focusIndex: -1,
      passwordVisible: false,

      checked:false,
      Loading:false,
      dataForm: {
        username: "",
        password: "",
        token: "",
      },
      
      disabled:false,
      disabledStr:'',
      retryTimer:null,
    }
  },
  inject: ['updateButtons'],
  computed: {
    rules() {
      return {
        username:[
          {required: true, message: this.$t("login.fields.email_placeholder"), trigger: 'blur'},
        ],
        password:[
          {required: true, message: this.$t("login.fields.password_placeholder"), trigger: 'blur'},
        ]
      }
    }
  },
  mounted() {
    this.updateButtons(false, true);
  },
  beforeDestroy() {
    if (this.retryTimer) clearTimeout(this.retryTimer);
  },
  methods: {
    verify(token) {
      this.dataForm.token = token;
    },
    onTurnstileFailed() {
      console.log('Turnstile failed');
    },
    open(){
        this.$refs.modalPrivacy.open()
    },
    openSignUp() {
      this.$router.push({path:'/signup', query: {redirect: this.$route.query?.redirect ?? ''}})
    },
    clickLogin(formName) {
      if (!this.dataForm.token) {
        return
      }
      if(!this.checked){
          this.$refs.modalPrivacy.open()
          return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          return false;
        }
      });
    },
    clickAgreePrivacy() {
      this.checked = true;
      this.save();
    },
    save() {
      this.Loading = true;
      login({
          ...this.dataForm,
          password: cookieAuthEnabled ? this.dataForm.password : md5(this.dataForm.password)
      }).then(res=>{
        if(res.code === 1){
          if (cookieAuthEnabled) {
            saveCookieAuthState(res.data.csrfToken)
            localStorage.removeItem('token')
          } else {
            localStorage.setItem('token',res.data.token)
          }
          this.getUsers();
        } else {
          this.Loading = false;
        }
      }).catch((e)=>{
        this.Loading = false;
        const response = e?.response || e;
        if (response?.status === 429) {
          const seconds = Math.max(1, Math.min(1800, Number(response.headers?.['retry-after']) || 60));
          this.disabled = true;
          this.disabledStr = `${seconds}s`;
          this.$message.warning(response.data?.msg || this.$t("login.message.times_limit"));
          if (this.retryTimer) clearTimeout(this.retryTimer);
          this.retryTimer = setTimeout(() => {
            this.disabled = false;
            this.disabledStr = '';
            this.retryTimer = null;
          }, seconds * 1000);
        }
      })
    },
    getUsers(){
      getUser().then(res=>{
        this.Loading = false;

        if(res.code === 1){
          this.$message.success('Login succeeded.');
          
          localStorage.setItem('users', JSON.stringify(res.data))
          this.$store.commit('vuexSetLogin',true);
          this.$store.commit('vuexSetUser', res.data);

          // 获取重定向路径
          const redirectPath = this.$route.query?.redirect ? decodeURIComponent(this.$route.query.redirect) : '/ucenter/info';
          this.$router.replace(redirectPath);
        }
      }).catch((e)=>{
        this.Loading = false;

        // this.$message.error('data' in e && 'msg' in e.data ? e?.data.msg : this.$t("login.message.load_fail"));
      })
    }
  }
}
</script>
